import { WatchListService } from '@/modules/shared/services/watchlist.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

// Create a new service instance for the WatchListService
const watchlistService = new WatchListService();
// Export module state
export const state = {
  watchlist: []
};
// Export module mutations
export const mutations = {
  ...make.mutations(state)
};
// Export module actions
export const actions = {
  // Get all stages
  batchQueryWatchlist: async (_, params) => {
    try {
      const { data } = await watchlistService.batchQueryWatchlist(params);
      return data;
    } catch (error) {
      Logger.error('getting batch watchlist results', error);
      throw error;
    }
  },
  // Update stage
  queryWatchlist: async (_, payload) => {
    try {
      let { data } = await watchlistService.queryWatchlist(payload);
      return data;
    } catch (error) {
      Logger.error('updating workflow stages', error);
      throw error;
    }
  }
};
// Export module getters
export const getters = {
  ...make.getters(state)
};
